<template>
  <div>
    <b-card>
      <div class="quote-visibility mb-75">
        <div class="quote-visibility__head">
          <span class="quote-visibility__label">Así la ve el cliente</span>
          <b-badge :variant="isQuoteOpen ? 'light-success' : 'light-secondary'">
            {{ isQuoteOpen ? 'ABIERTA' : 'CERRADA' }}
          </b-badge>
        </div>
        <b-button
          size="sm"
          :variant="isQuoteOpen ? 'outline-secondary' : 'outline-success'"
          block
          :disabled="isSavingVisibility"
          @click="toggleQuoteVisibility"
        >
          <b-spinner
            v-if="isSavingVisibility"
            small
            class="mr-50"
          />
          {{ isQuoteOpen ? 'Cerrar cotización' : 'Abrir cotización' }}
        </b-button>
      </div>
      <div class="quote-visibility mb-75">
        <div class="quote-visibility__head">
          <span class="quote-visibility__label">Comparativa</span>
        </div>
        <b-form-radio-group
          :checked="comparativeLayout"
          buttons
          size="sm"
          button-variant="outline-primary"
          :disabled="isSavingLayout"
          :options="comparativeLayoutOptions"
          @change="saveComparativeLayout"
        />
      </div>
      <b-button
        variant="info"
        class="mb-75"
        block
        @click="
          $router.push({
            name: 'clientQuoteMetadata',
            params: { id: quote.id },
          })
        "
      >
        <feather-icon
          icon="EyeIcon"
          class="mr-1"
        />
        {{ $t('breakdown') }}
      </b-button>
      <b-button
        v-if="!quoteHasPaymentActivity"
        :variant="paymentWindowExpired ? 'primary' : 'outline-primary'"
        class="mb-75"
        block
        :disabled="isRequoting"
        @click="openRequoteConfirm('refresh')"
      >
        <b-spinner
          v-if="isRequoting && pendingRequoteMode === 'refresh'"
          small
          class="mr-50"
        />
        {{ $t('updateQuote') }}
      </b-button>
      <b-button
        variant="outline-primary"
        class="mb-75"
        block
        :disabled="isRequoting"
        @click="openRequoteConfirm('duplicate')"
      >
        <b-spinner
          v-if="isRequoting && pendingRequoteMode === 'duplicate'"
          small
          class="mr-50"
        />
        {{ $t('duplicateQuote') }}
      </b-button>
      <!-- Button: See uploaded document -->
      <b-button
        variant="outline-secondary"
        class="mb-75"
        block
        @click="printInvoice"
      >
        {{ $t('print') }}
      </b-button>
      <b-button
        variant="outline-dark"
        class="mb-75"
        block
        @click="openPrintPurchaseOrderModal"
      >
        {{ $t('purchaseOrderPrint.action') }}
      </b-button>
      <b-button
        :to="{
          name: 'quoteInvoices',
          params: { quoteId: this.$route.params.quoteId },
        }"
        variant="outline-success"
        class="mb-75"
        block
      >
        {{ $t('invoice2') }}
      </b-button>

      <!-- <b-button
        :to="{ name: 'clientQuote' }"
        variant="outline-secondary"
        class="mb-75"
        block
      >
        {{ $t('edit') }}
      </b-button> -->
      <b-card>
        <p>{{ payment.name }}</p>
        <p>{{ $t('bank') }}: {{ payment.bankName }}</p>
        <p class="mb-0">
          {{ $t('accountNumber') }}:
        </p>
        <p>{{ payment.accountNumber }}</p>
        <p class="mb-0">
          {{ $t('clabe') }}:
        </p>
        <p>{{ payment.clabe }}</p>
        <p class="mb-0">
          {{ $t('card') }}:
        </p>
        <p>{{ payment.card }}</p>
      </b-card>
      <b-button
        v-if="
          quote.payment_attachment != '/default.jpg' &&
            quote.payment_attachment != null
        "
        variant="outline-primary"
        class="mb-75"
        block
        target="_blank"
        :href="quote.payment_attachment"
      >
        {{ $t('invoice') }}
      </b-button>
      <!-- OLD PAYMENT VIEW -->
      <!-- <b-button
        :to="{
          name: 'bankAccountData',
          params: { quoteId: $route.params.quoteId },
        }"
        variant="success"
        class="mb-75"
        block
      >
        {{ $t('payment') }}
      </b-button> -->

      <!-- NEW PAYMENT IN MODAL -->
      <UploadPayment
        v-if="!paymentWindowExpired && hasTaxInformationLinked"
        ref="uploadPaymentRef"
        :quote="quote"
        @uploaded="handlePaymentStateChange"
        @removed="handlePaymentStateChange"
      />
      <b-button
        v-else-if="!paymentWindowExpired"
        variant="success"
        class="mb-75"
        block
        @click="openTaxInformationModal('upload')"
      >
        {{ $t('addPayment') }}
      </b-button>

      <b-alert
        v-else
        show
        variant="danger"
        class="mb-1"
      >
        No se puede subir comprobante: la cotización ya no está dentro del mismo mes de la cotización.
      </b-alert>

      <!-- Button: Reject Payment -->
      <div class="mt-2">

        <b-alert
          v-if="paymentWindowExpired"
          show
          variant="danger"
          class="mb-1"
        >
          <div class="font-weight-bolder mb-25">
            Cotización vencida
          </div>
          <div>
            Ya no está dentro del mes de su creación, por lo que no se puede pagar, aprobar ni acreditar. Actualízala para reenviarla a subasta y reactivar el pago; el folio se mantiene.
          </div>
        </b-alert>
        <b-alert
          v-else-if="paymentDeadlineLabel && deadlineUpcoming"
          show
          :variant="deadlineVariant"
          class="mb-1"
        >
          <div>
            Se puede pagar/aprobar hasta: <strong>{{ paymentDeadlineLabel }}</strong>
            <span v-if="deadlineUrgent"> — ¡queda poco tiempo!</span>
          </div>
        </b-alert>

        <b-button
          v-if="quote.payment_status === 'awaiting_payment_approval'"
          v-b-modal.confirmReject
          variant="outline-danger"
          class="mb-75"
          block
        >
          {{ $t('rejectReceiptAction') }}
        </b-button>

        <!-- Button: Approve Payment -->
        <b-button
          v-if="quote.payment_status === 'awaiting_payment_approval'"
          variant="outline-success"
          class="mb-75"
          block
          :disabled="paymentWindowExpired"
          @click="openApproveFlow"
        >
          {{ $t('approveReceiptAction') }}
        </b-button>

        <!-- Button: Credit Payment -->
        <b-button
          v-if="adminPaymentSelectionAvailable && quote.payment_status !== 'awaiting_payment_approval'"
          variant="outline-primary"
          class="mb-75"
          block
          :disabled="paymentWindowExpired"
          @click="openTaxInformationModal('paymentSelection')"
        >
          {{ $t('selectCreditModeAction') }}
        </b-button>

        <b-button
          v-else-if="customerCreditEligible && ['payment_pending', 'payment_rejected'].includes(quote.payment_status)"
          variant="outline-warning"
          class="mb-75"
          block
          :disabled="paymentWindowExpired"
          @click="openTaxInformationModal('credit')"
        >
          {{ $t('credit') }}
        </b-button>

        <b-button
          variant="outline-info"
          class="mb-75"
          block
          :disabled="paymentWindowExpired || quote.is_paid || Number(remainingToPay) <= 0"
          @click="openTaxInformationModal('wallet')"
        >
          {{ $t('payWithWallet') || 'Pagar con Monedero' }}
        </b-button>

      </div>
    </b-card>

    <b-modal
      id="selectTaxInformationForPaymentAdmin"
      title="Selecciona razón social"
      ok-title="Continuar"
      cancel-title="Cancelar"
      @ok="confirmTaxInformationSelection"
      @hidden="resetTaxInformationModal"
    >
      <div v-if="taxInformationLoading">
        Cargando razones sociales...
      </div>
      <div v-else-if="taxInformationOptions.length === 0">
        <p class="mb-1">
          Debes registrar una razón social de facturación para poder continuar con el pago.
        </p>
        <b-button
          variant="primary"
          @click="goToNewBilling"
        >
          Registrar razón social
        </b-button>
      </div>
      <div v-else>
        <p class="mb-1">Selecciona la razón social que se asignará a esta cotización.</p>
        <b-form-select
          v-model="selectedTaxInformationId"
          :options="taxInformationSelectOptions"
        />
      </div>
    </b-modal>

    <b-modal
      id="selectPaymentModeBeforeApproval"
      :title="hasPendingProofApproval ? $t('selectPaymentModeBeforeApproval') : $t('selectCreditModeTitle')"
      :ok-title="hasPendingProofApproval ? 'Autorizar' : 'Aplicar'"
      cancel-title="Cancelar"
      @ok="confirmPaymentSelection"
      @hidden="resetPaymentSelection"
    >
      <p class="mb-1">
        {{ hasPendingProofApproval ? $t('selectPaymentModeHelp') : $t('selectCreditModeHelp') }}
      </p>
      <b-form-radio-group
        v-model="selectedApprovalMode"
        stacked
      >
        <b-form-radio
          v-if="hasPendingProofApproval"
          value="cash"
          :disabled="!canApproveCash"
          class="mb-1"
        >
          <div class="d-flex flex-column">
            <strong>{{ $t('cashAmountLabel') }}</strong>
            <span>{{ formatMoney(cashTotalAmount) }}</span>
            <small
              v-if="!canApproveCash"
              class="text-muted"
            >
              {{ $t('cashApprovalRequiresPaymentProof') }}
            </small>
          </div>
        </b-form-radio>
        <b-form-radio value="credit_without_surcharge">
          <div class="d-flex flex-column">
            <strong>{{ $t('creditNoSurchargeAmountLabel') }}</strong>
            <span>{{ formatMoney(cashTotalAmount) }}</span>
            <small class="text-muted">
              {{ $t('creditWithoutSurchargeNote') }}
            </small>
            <small
              v-if="creditLimitWarningWithoutSurcharge"
              class="text-danger font-weight-semibold mt-50"
            >
              Excedería la línea de crédito por {{ formatMoney(creditLimitWarningWithoutSurcharge.excessAmount) }}.
            </small>
          </div>
        </b-form-radio>
        <b-form-radio value="credit_with_surcharge">
          <div class="d-flex flex-column">
            <strong>{{ $t('creditAmountLabel') }}</strong>
            <span>{{ formatMoney(creditTotalAmount) }}</span>
            <small class="text-muted">
              {{ $t('creditAmountSurchargeNote', { percentage: creditSurchargePercentage }) }}
            </small>
            <small
              v-if="creditLimitWarningWithSurcharge"
              class="text-danger font-weight-semibold mt-50"
            >
              Excedería la línea de crédito por {{ formatMoney(creditLimitWarningWithSurcharge.excessAmount) }}.
            </small>
          </div>
        </b-form-radio>
      </b-form-radio-group>
      <b-alert
        v-if="selectedCreditLimitWarning"
        show
        variant="warning"
        class="mt-1 mb-0"
      >
        Crédito disponible actual: {{ formatMoney(selectedCreditLimitWarning.available) }}.
        Si continúas, quedará en {{ formatMoney(selectedCreditLimitWarning.projectedAvailable) }}.
      </b-alert>
    </b-modal>

    <b-modal
      id="printPurchaseOrderBySupplierAdmin"
      :title="$t('purchaseOrderPrint.selectSupplierTitle')"
      :ok-title="$t('purchaseOrderPrint.printButton')"
      :cancel-title="$t('cancel') || 'Cancelar'"
      @ok="printPurchaseOrderBySupplier"
    >
      <div v-if="purchaseOrderSupplierSelectOptions.length === 0">
        {{ $t('purchaseOrderPrint.noSuppliers') }}
      </div>
      <div v-else>
        <p class="mb-1">
          {{ $t('purchaseOrderPrint.selectSupplierHelp') }}
        </p>
        <b-form-group :label="$t('purchaseOrderPrint.selectSupplierLabel')">
          <b-form-select
            v-model="selectedPurchaseOrderSupplierId"
            :options="purchaseOrderSupplierSelectOptions"
          />
        </b-form-group>
      </div>
    </b-modal>

    <!-- Modals Confirmation: Approve -->
    <confirmation-modal
      v-if="quote.payment_status === 'awaiting_payment_approval'"
      :id="'confirmApprove'"
      :variant="'success'"
      @confirm="approvePayment"
    >
      <template v-slot:content>
        {{ $t('approveReceiptConfirmation') }}
      </template>
    </confirmation-modal>

    <!-- Modals Confirmation: Reject -->
    <confirmation-modal
      v-if="quote.payment_status === 'awaiting_payment_approval'"
      :id="'confirmReject'"
      :variant="'danger'"
      @confirm="rejectPayment"
    >
      <template v-slot:content>
        {{ $t('rejectReceiptConfirmation') }}
      </template>
    </confirmation-modal>

    <!-- Modals Confirmation: Credit -->
    <confirmation-modal
      :id="'confirmCredit'"
      :variant="'warning'"
      @confirm="creditPayment"
    >
      <template v-slot:content>
        <div>
          <p class="mb-50">
            {{ $t('creditPaymentConfirmation') }}
          </p>
          <p
            v-if="creditLimitWarningWithSurcharge"
            class="mb-0 text-danger font-weight-semibold"
          >
            Esta autorización dejaría el crédito en {{ formatMoney(creditLimitWarningWithSurcharge.projectedAvailable) }}
            y excedería el límite por {{ formatMoney(creditLimitWarningWithSurcharge.excessAmount) }}.
          </p>
        </div>
      </template>
    </confirmation-modal>

    <confirmation-modal
      :id="'confirmWallet'"
      :variant="'info'"
      @confirm="payWithWalletConfirm"
    >
      <template v-slot:content>
        <div>
          <p class="mb-50">
            {{ $t('confirmWalletPayment') || '¿Confirmas pagar esta cotización con tu monedero?' }}
          </p>
          <ul class="mb-0">
            <li>
              {{ $t('quoteFolio') || 'Folio' }}:
              <strong>{{ quote.folio }}</strong>
            </li>

            <li>
              {{ $t('subtotal') || 'Subtotal' }}:
              <strong>{{ formatMoney(subtotal) }}</strong>
            </li>
            <li>
              {{ $t('shipping') || 'Flete' }}:
              <strong>{{ formatMoney(shippingTotal) }}</strong>
            </li>
            <li>
              {{ $t('vat') || 'IVA' }}:
              <strong>{{ formatMoney(ivaTotal) }}</strong>
            </li>
            <li>
              {{ $t('totalWithVAT') || 'Total con IVA' }}:
              <strong>{{ formatMoney(total) }}</strong>
            </li>

            <li v-if="paymentsSum > 0">
              {{ $t('alreadyPaid') || 'Pagado' }}:
              <strong>{{ formatMoney(paymentsSum) }}</strong>
            </li>
            <li>
              {{ $t('toCharge') || 'A cobrar' }}:
              <strong>{{ formatMoney(remainingToPay) }}</strong>
            </li>
            <li>
              {{ $t('walletBalance') || 'Saldo del monedero' }}:
              <strong>{{ formatMoney(walletBalance) }}</strong>
            </li>
          </ul>
        </div>
      </template>
    </confirmation-modal>
    <confirmation-modal
      :id="'confirmRequote'"
      :variant="'warning'"
      @confirm="onRequoteQuote"
    >
      <template v-slot:content>
        <div>{{ requoteConfirmMessage }}</div>
      </template>
    </confirmation-modal>

    <PaymentsModal id="payments-modal" />
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { COMPANY_LEGAL_NAME } from '@/utils/company'
import ConfirmationModal from '@/components/ConfirmationModal.vue'
import PaymentsModal from '@/components/payments/PaymentsModal.vue'
import UploadPayment from '@/components/payments/UploadPayment.vue'
import resolveQuoteRoute from '@/utils/quoteRoute'
import { quoteHasPaymentActivity as hasPaymentActivity } from '@/utils/quotePurchase'

export default {
  components: {
    ConfirmationModal,
    PaymentsModal,
    UploadPayment,
  },
  props: {
    quote: {
      type: Object,
      default() {
        return {}
      },
    },
    items: {
      type: Array,
      default() {
        return []
      },
    },
    project: {
      type: Object,
      default() {
        return {}
      },
    },
    supplierData: {
      type: Array,
      default() {
        return []
      },
    },
    refetch: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      payment: {
        bankName: 'Santander',
        accountNumber: '65-50969732-6',
        clabe: '014580655096973264',
        card: '5579 0890 0447 7553',
        name: 'PLATAFORMA DIGITAL YOC SAPI DE CV',
      },
    }
  },
  setup(props, { root }) {
    const store = root.$store
    const isRequoting = ref(false)

    // El admin ve la cotizacion como la ve el cliente, asi que necesita poder abrirla o
    // cerrarla desde aqui mismo sin irse a la comparativa.
    const isSavingVisibility = ref(false)
    const isQuoteOpen = computed(() => Boolean(props.quote?.open_quotation_enabled))

    // Formato con el que se pinta la comparativa en la cotizacion: el desglose por partida
    // que existe hoy, o la matriz de material por proveedor.
    const isSavingLayout = ref(false)
    const comparativeLayout = computed(() => props.quote?.comparative_layout || 'detail')
    const comparativeLayoutOptions = [
      { value: 'detail', text: 'Detalle' },
      { value: 'table', text: 'Tabla' },
    ]

    const saveComparativeLayout = async layout => {
      if (isSavingLayout.value || !props.quote?.id || layout === comparativeLayout.value) return

      isSavingLayout.value = true

      try {
        await store.dispatch('quotes/updateQuoteComparativeLayout', {
          quoteId: props.quote.id,
          comparativeLayout: layout,
        })

        if (props.refetch) await props.refetch()
      } finally {
        isSavingLayout.value = false
      }
    }

    const toggleQuoteVisibility = async () => {
      if (isSavingVisibility.value || !props.quote?.id) return

      isSavingVisibility.value = true

      try {
        await store.dispatch('quotes/updateQuoteOpenQuotation', {
          quoteId: props.quote.id,
          openQuotation: !isQuoteOpen.value,
        })

        if (props.refetch) await props.refetch()
      } finally {
        isSavingVisibility.value = false
      }
    }

    // ---- Totales tomados directamente de la prop quote ----
    const q = computed(() => props.quote || {})
    const quoteHasPaymentActivity = computed(() => hasPaymentActivity(q.value))
    const pendingRequoteMode = ref('refresh')
    const quoteId = computed(() => root.$route.params.quoteId || q.value?.id || null)
    const quoteCustomerId = computed(() => q.value?.customer_attributes?.id
      || q.value?.customer?.id
      || q.value?.customer_id
      || q.value?.customerId
      || null)
    const storeQuote = computed(() => store.state.quotes?.quote || {})
    const isSameQuoteInStore = computed(() => {
      const currentId = q.value?.id || quoteId.value
      const storeId = storeQuote.value?.id
      if (!currentId || !storeId) return false
      return String(storeId) === String(currentId)
    })
    const hasTaxInformationLinked = computed(() => Boolean(
      q.value?.tax_information_id
      || q.value?.taxable_id
      || q.value?.tax_information?.id
      || (isSameQuoteInStore.value && (
        storeQuote.value?.tax_information_id
        || storeQuote.value?.taxable_id
      )),
    ))

    const paymentWindowExpired = computed(() => Boolean(
      q.value?.admin_payment_window_expired ?? q.value?.payment_window_expired,
    ))
    const paymentDeadlineAt = computed(() => q.value?.admin_payment_deadline_at || q.value?.payment_deadline_at || null)

    const formatDeadline = value => {
      if (!value) return ''
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return ''
      return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(d)
    }

    const paymentDeadlineLabel = computed(() => formatDeadline(paymentDeadlineAt.value))

    const hoursUntilDeadline = computed(() => {
      if (!paymentDeadlineAt.value) return null
      const d = new Date(paymentDeadlineAt.value)
      if (Number.isNaN(d.getTime())) return null
      return (d.getTime() - Date.now()) / (1000 * 60 * 60)
    })

    const deadlineUpcoming = computed(() => hoursUntilDeadline.value !== null && hoursUntilDeadline.value > 0)

    const deadlineUrgent = computed(() => deadlineUpcoming.value && hoursUntilDeadline.value <= 48)

    const deadlineVariant = computed(() => (deadlineUrgent.value ? 'warning' : 'info'))

    const requoteConfirmMessage = computed(() => (pendingRequoteMode.value === 'duplicate'
      ? 'Se creará una copia nueva de esta cotización. ¿Continuar?'
      : 'Se reenviará la cotización a subasta para buscar precios actualizados. El folio se mantiene y se reactiva la ventana de pago. ¿Continuar?'))

    const openRequoteConfirm = mode => {
      pendingRequoteMode.value = mode
      root.$bvModal.show('confirmRequote')
    }

    const selectedPurchaseOrderSupplierId = ref(null)
    const selectedApprovalMode = ref('cash')

    const walletBalance = computed(() => Number(store.state.wallet.walletMe?.data?.balance || 0))
    const taxInformationLoading = ref(false)
    const taxInformationOptions = ref([])
    const selectedTaxInformationId = ref(null)
    const pendingPaymentAction = ref(null)
    const uploadPaymentRef = ref(null)
    const taxInformationSelectOptions = computed(() => (taxInformationOptions.value || []).map(item => ({
      value: item.id,
      text: `${item.corporate_name} (${item.rfc})`,
    })))
    const customerCreditEligible = computed(() => Boolean(q.value?.customer_credit_eligible))
    const paymentSelectionAvailable = computed(() => Boolean(q.value?.payment_selection_available))
    const creditSurchargePercentage = computed(() => Number(q.value?.credit_surcharge_percentage || 2))
    const canApproveCash = computed(() => q.value?.payment_status === 'awaiting_payment_approval')
    const hasPendingProofApproval = computed(() => q.value?.payment_status === 'awaiting_payment_approval')
    const canApproveUploadedProof = computed(() => q.value?.payment_status === 'awaiting_payment_approval')
    const adminPaymentSelectionAvailable = computed(() => {
      const status = q.value?.payment_status

      return customerCreditEligible.value
        && !paymentWindowExpired.value
        && ['payment_pending', 'payment_rejected'].includes(status)
    })
    const creditLimitWarningWithSurcharge = computed(() => {
      const excessAmount = Number(q.value?.customer_credit_excess_with_surcharge || 0)
      if (excessAmount <= 0) return null

      return {
        excessAmount,
        available: Number(q.value?.customer_credit_available_amount || 0),
        projectedAvailable: Number(q.value?.customer_credit_projected_available_with_surcharge || 0),
      }
    })
    const creditLimitWarningWithoutSurcharge = computed(() => {
      const excessAmount = Number(q.value?.customer_credit_excess_without_surcharge || 0)
      if (excessAmount <= 0) return null

      return {
        excessAmount,
        available: Number(q.value?.customer_credit_available_amount || 0),
        projectedAvailable: Number(q.value?.customer_credit_projected_available_without_surcharge || 0),
      }
    })
    const selectedCreditLimitWarning = computed(() => {
      if (selectedApprovalMode.value === 'credit_without_surcharge') return creditLimitWarningWithoutSurcharge.value
      if (selectedApprovalMode.value === 'credit_with_surcharge') return creditLimitWarningWithSurcharge.value
      return null
    })

    const getErrorPayload = error => error?.response?.data || error?.data || {}
    const getErrorMessage = (error, fallback = 'Ocurrió un error al procesar la solicitud.') => {
      const payload = getErrorPayload(error)
      if (Array.isArray(payload.messages) && payload.messages.length > 0) return payload.messages[0]
      if (typeof payload.error === 'string') return payload.error
      if (typeof error?.message === 'string') return error.message
      return fallback
    }
    const getErrorCode = error => getErrorPayload(error)?.code

    function toast({ title, variant = 'success' }) {
      root.$toast({
        component: ToastificationContent,
        props: { title, icon: 'CreditCardIcon', variant },
      })
    }

    const openUploadDialog = () => {
      if (uploadPaymentRef.value && typeof uploadPaymentRef.value.openFileInput === 'function') {
        uploadPaymentRef.value.openFileInput()
        return
      }
      toast({ title: 'Razón social asignada. Ahora puedes subir el comprobante.', variant: 'success' })
    }

    const loadWalletForQuote = async () => {
      const quoteCust = quoteCustomerId.value
      if (!quoteCust) throw new Error('La cotización no trae customer_id')
      // Forzar SIEMPRE búsqueda por cliente (vista admin)
      await store.dispatch('wallet/fetchWalletByCustomer', { customerId: quoteCust })
    }

    const loadTaxInformationOptions = async () => {
      if (!quoteId.value) {
        toast({ title: 'No se encontró la cotización para cargar razones sociales.', variant: 'danger' })
        return false
      }

      try {
        taxInformationLoading.value = true
        const response = await store.dispatch('quotes/fetchQuoteTaxInformationOptions', { quoteId: quoteId.value })
        taxInformationOptions.value = response?.data || []
        selectedTaxInformationId.value = response?.selected_tax_information_id
          || response?.project_default_tax_information_id
          || response?.customer_default_tax_information_id
          || taxInformationOptions.value?.[0]?.id
          || null
        return true
      } catch (error) {
        toast({ title: getErrorMessage(error, 'No se pudo cargar el catálogo fiscal.'), variant: 'danger' })
        return false
      } finally {
        taxInformationLoading.value = false
      }
    }

    const assignTaxInformationToQuote = async taxInformationId => {
      if (!quoteId.value || !taxInformationId) return false

      try {
        await store.dispatch('quotes/setQuoteTaxInformation', {
          quoteId: quoteId.value,
          taxInformationId,
        })
        await store.dispatch('quotes/fetchQuote', quoteId.value)
        return true
      } catch (error) {
        toast({ title: getErrorMessage(error, 'No fue posible asignar la razón social.'), variant: 'danger' })
        return false
      }
    }

    function preferredApprovalMode() {
      if (q.value?.selected_payment_mode === 'credit') {
        return q.value?.apply_credit_surcharge ? 'credit_with_surcharge' : 'credit_without_surcharge'
      }

      return canApproveCash.value ? 'cash' : 'credit_with_surcharge'
    }

    function resetPaymentSelection() {
      selectedApprovalMode.value = preferredApprovalMode()
    }

    async function openTaxInformationModal(action) {
      if (hasTaxInformationLinked.value) {
        if (action === 'upload') {
          openUploadDialog()
          return
        }
        if (action === 'approve') {
          root.$bvModal.show('confirmApprove')
          return
        }
        if (action === 'credit') {
          root.$bvModal.show('confirmCredit')
          return
        }
        if (action === 'paymentSelection') {
          resetPaymentSelection()
          root.$bvModal.show('selectPaymentModeBeforeApproval')
          return
        }
        if (action === 'wallet') {
          try {
            await loadWalletForQuote()
            root.$bvModal.show('confirmWallet')
          } catch (error) {
            toast({ title: getErrorMessage(error, 'No se pudo cargar el monedero.'), variant: 'danger' })
          }
          return
        }
      }

      if (!quoteId.value) {
        toast({ title: 'No se encontró la cotización.', variant: 'danger' })
        return
      }
      pendingPaymentAction.value = action

      const loaded = await loadTaxInformationOptions()
      if (!loaded) return

      root.$bvModal.show('selectTaxInformationForPaymentAdmin')
    }

    async function confirmTaxInformationSelection(modalEvent) {
      if (!selectedTaxInformationId.value) {
        modalEvent.preventDefault()
        toast({ title: 'Selecciona una razón social para continuar.', variant: 'warning' })
        return
      }

      modalEvent.preventDefault()
      const assigned = await assignTaxInformationToQuote(selectedTaxInformationId.value)
      if (!assigned) return

      root.$bvModal.hide('selectTaxInformationForPaymentAdmin')

      if (pendingPaymentAction.value === 'upload') {
        await root.$nextTick()
        openUploadDialog()
        return
      }

      if (pendingPaymentAction.value === 'credit') {
        root.$bvModal.show('confirmCredit')
        return
      }

      if (pendingPaymentAction.value === 'paymentSelection') {
        resetPaymentSelection()
        root.$bvModal.show('selectPaymentModeBeforeApproval')
        return
      }

      if (pendingPaymentAction.value === 'approve') {
        root.$bvModal.show('confirmApprove')
        return
      }

      if (pendingPaymentAction.value === 'wallet') {
        try {
          await loadWalletForQuote()
          root.$bvModal.show('confirmWallet')
        } catch (error) {
          toast({ title: getErrorMessage(error, 'No se pudo cargar el monedero.'), variant: 'danger' })
        }
      }
    }

    function resetTaxInformationModal() {
      pendingPaymentAction.value = null
    }

    function goToNewBilling() {
      root.$bvModal.hide('selectTaxInformationForPaymentAdmin')
      root.$router.push({
        name: 'new-billing',
        params: quoteCustomerId.value ? { customerId: quoteCustomerId.value } : {},
      })
    }

    function openApproveFlow() {
      openTaxInformationModal('approve')
    }

    // pagos asociados a la cotización (ya los tienes en el store)
    const payments = computed(() => store.getters['quotes/quotePayments'])
    const printInvoice = () => {
      window.print()
    }
    const apiUrl = computed(() => store.state.apiUrl)

    const formatMoney = n => {
      try {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' })
          .format(Number(n || 0))
      } catch {
        return `$${Number(n || 0).toFixed(2)}`
      }
    }
    const formatMoneyNoCurrency = n => {
      try {
        return new Intl.NumberFormat('es-MX', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(n || 0))
      } catch {
        return Number(n || 0).toFixed(2)
      }
    }
    const formatDate = value => {
      const d = value ? new Date(value) : new Date()
      if (Number.isNaN(d.getTime())) return ''
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}/${month}/${year}`
    }
    const toNumber = value => {
      const n = Number(value)
      return Number.isFinite(n) ? n : 0
    }
    const roundMoney = value => Math.round(toNumber(value) * 100) / 100
    const escapeHtml = value => String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

    const quoteItems = computed(() => {
      if (Array.isArray(props.items) && props.items.length) return props.items
      if (Array.isArray(q.value?.quote_items_attributes)) return q.value.quote_items_attributes
      return []
    })

    const normalizeText = value => String(value || '').trim()
    const normalizeSupplierKey = value => String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '')

    const getSupplierName = item => {
      // Este panel es solo del admin: si la cotizacion esta cerrada el nombre visible viene
      // enmascarado, pero la OC impresa lleva el proveedor real.
      const direct = normalizeText(
        item?.unmasked_supplier_branch_name
        || item?.selected_supplier_branch_name
        || item?.selected_supplier_name
        || item?.supplier_name
        || item?.branch_name
        || item?.business_name
        || item?.supplier,
      )
      if (direct) return direct

      const branchId = item?.selected_supplier_branch_id
      if (branchId && Array.isArray(props.supplierData)) {
        const found = props.supplierData.find(s => String(s?.id) === String(branchId))
        const fallback = normalizeText(
          found?.name
          || found?.branch_name
          || found?.supplier_name
          || found?.business_name,
        )
        if (fallback) return fallback
      }

      return root.$t('supplier')
    }

    const purchaseOrderSuppliers = computed(() => {
      const map = new Map()
      quoteItems.value
        .filter(item => item?.selected_supplier_branch_id && item?.active_status !== false)
        .forEach(item => {
          const supplierId = String(item.selected_supplier_branch_id)
          if (!map.has(supplierId)) {
            map.set(supplierId, {
              id: supplierId,
              name: getSupplierName(item),
              sortKey: normalizeSupplierKey(getSupplierName(item)),
            })
          }
        })
      return Array.from(map.values()).sort((a, b) => a.sortKey.localeCompare(b.sortKey))
    })

    const purchaseOrderSupplierSelectOptions = computed(() => [
      {
        value: null,
        text: root.$t('purchaseOrderPrint.selectSupplierPlaceholder'),
      },
      ...purchaseOrderSuppliers.value.map(supplier => ({
        value: supplier.id,
        text: supplier.name,
      })),
    ])

    const getItemTotalWithoutCommission = item => {
      if (item?.total_without_commission !== null && item?.total_without_commission !== undefined) {
        return roundMoney(item.total_without_commission)
      }
      return roundMoney(toNumber(item?.quantity) * toNumber(item?.unit_price))
    }

    const getItemUnitPriceWithoutCommission = item => {
      if (item?.unit_price !== null && item?.unit_price !== undefined) {
        return roundMoney(item.unit_price)
      }

      const quantity = toNumber(item?.quantity)
      const total = getItemTotalWithoutCommission(item)
      if (quantity <= 0) return 0
      return roundMoney(total / quantity)
    }

    const selectedPurchaseOrderItems = computed(() => {
      const selectedId = selectedPurchaseOrderSupplierId.value
      if (!selectedId) return []
      return quoteItems.value.filter(
        item => String(item?.selected_supplier_branch_id || '') === String(selectedId)
          && item?.active_status !== false,
      )
    })
    const selectedPurchaseOrderSupplier = computed(() => purchaseOrderSuppliers.value.find(
      supplier => String(supplier.id) === String(selectedPurchaseOrderSupplierId.value),
    ) || null)

    const getPurchaseOrderShippingAmount = supplierShippingEntry => {
      const directAmount = [
        supplierShippingEntry?.shipping_total,
        supplierShippingEntry?.shipping_price,
        supplierShippingEntry?.price,
        supplierShippingEntry?.amount,
        supplierShippingEntry?.cost,
      ].find(value => value !== null && value !== undefined && value !== '')

      if (directAmount !== undefined) return roundMoney(directAmount)

      const shippings = Array.isArray(supplierShippingEntry?.shippings)
        ? supplierShippingEntry.shippings
        : []

      const selectedShipping = shippings.find(shipping => shipping?.selected)
        || shippings.find(shipping => shipping?.is_selected)
        || shippings.find(shipping => shipping?.active)
        || (shippings.length === 1 ? shippings[0] : null)
        || null

      if (!selectedShipping) return 0

      return roundMoney(
        selectedShipping?.price
        ?? selectedShipping?.amount
        ?? selectedShipping?.cost
        ?? selectedShipping?.shipping_total
        ?? 0,
      )
    }

    const purchaseOrderShippingTotal = computed(() => {
      if (q.value?.without_freight) return 0

      const selectedSupplierId = selectedPurchaseOrderSupplierId.value
      const selectedSupplierName = normalizeSupplierKey(selectedPurchaseOrderSupplier.value?.name)
      const supplierBranchShippings = Array.isArray(q.value?.supplier_branches_shippings)
        ? q.value.supplier_branches_shippings
        : []

      if (!selectedSupplierId) return 0

      const freightOverride = (q.value?.freight_overrides || {})[String(selectedSupplierId)]
      if (freightOverride !== undefined) return roundMoney(toNumber(freightOverride))

      const itemsShippingTotal = roundMoney(
        selectedPurchaseOrderItems.value.reduce(
          (sum, item) => sum + toNumber(
            item?.shipping_price
            ?? item?.shipping_total
            ?? item?.freight
            ?? 0,
          ),
          0,
        ),
      )

      if (itemsShippingTotal > 0) return itemsShippingTotal

      const matchingEntries = supplierBranchShippings.filter(entry => {
        const candidateIds = [
          entry?.id,
          entry?.supplier_branch_id,
          entry?.branch_id,
          entry?.selected_supplier_branch_id,
          entry?.supplier_id,
        ].filter(value => value !== null && value !== undefined && value !== '')

        if (candidateIds.some(id => String(id) === String(selectedSupplierId))) return true

        const entryName = normalizeSupplierKey(
          entry?.name
          || entry?.supplier_name
          || entry?.branch_name
          || entry?.supplier_branch_name
          || entry?.business_name,
        )

        return Boolean(selectedSupplierName && entryName && entryName === selectedSupplierName)
      })

      if (matchingEntries.length) {
        return roundMoney(
          matchingEntries.reduce(
            (sum, entry) => sum + getPurchaseOrderShippingAmount(entry),
            0,
          ),
        )
      }

      if (purchaseOrderSuppliers.value.length === 1) {
        return roundMoney(q.value?.shipping_total || 0)
      }

      return 0
    })

    const purchaseOrderSubtotal = computed(() => roundMoney(
      selectedPurchaseOrderItems.value.reduce(
        (acc, item) => acc + getItemTotalWithoutCommission(item),
        0,
      ),
    ))

    const purchaseOrderVatRate = computed(() => {
      const raw = toNumber(q.value?.iva_percentage ?? q.value?.iva ?? 16)
      if (raw <= 0) return 0.16
      if (raw > 1) return raw / 100
      return raw
    })

    const purchaseOrderTaxableAmount = computed(
      () => roundMoney(purchaseOrderSubtotal.value + purchaseOrderShippingTotal.value),
    )
    const purchaseOrderVatTotal = computed(
      () => roundMoney(purchaseOrderTaxableAmount.value * purchaseOrderVatRate.value),
    )
    const purchaseOrderGrandTotal = computed(
      () => roundMoney(
        purchaseOrderSubtotal.value
        + purchaseOrderShippingTotal.value
        + purchaseOrderVatTotal.value,
      ),
    )

    const buildPurchaseOrderPrintHtml = ({
      supplierName,
      projectName,
      projectAddress,
      projectMapsUrl,
      observations,
      rows,
      subtotalAmount,
      shippingAmount,
      vatAmount,
      totalAmount,
      dateText,
      ocFolio,
      paymentCondition,
      buyerName,
      directorName,
      directorRole,
    }) => {
      const maxRows = 12
      const emptyRows = Math.max(0, maxRows - rows.length)
      // Absoluta a proposito: el documento se escribe en una ventana about:blank, donde una
      // ruta relativa no resuelve. Vive en public/ y no en assets/ para que un require() a
      // un archivo que falte no tumbe la compilacion; si no esta, el onerror quita la imagen.
      const signatureUrl = `${window.location.origin}${process.env.BASE_URL}img/orden-de-compra/firma.png`
      const tableRows = rows
        .map(row => `
          <tr>
            <td class="ta-c">${escapeHtml(row.quantity)}</td>
            <td class="ta-c">${escapeHtml(row.unit)}</td>
            <td>${escapeHtml(row.description)}</td>
            <td class="ta-r">$ ${escapeHtml(formatMoneyNoCurrency(row.unitPrice))}</td>
            <td class="ta-r">$ ${escapeHtml(formatMoneyNoCurrency(row.amount))}</td>
          </tr>
        `)
        .join('')
      const fillerRows = Array.from({ length: emptyRows }, () => `
        <tr class="filler">
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      `).join('')

      return `
        <!doctype html>
        <html lang="es">
          <head>
            <meta charset="utf-8" />
            <title>${escapeHtml(root.$t('purchaseOrderPrint.orderTitle'))}</title>
            <style>
              * { box-sizing: border-box; }
              body {
                margin: 0;
                font-family: Arial, sans-serif;
                color: #111827;
                background: #fff;
              }
              .sheet {
                width: 210mm;
                margin: 0 auto;
                padding: 10mm 12mm;
              }
              .title {
                text-align: center;
                font-size: 34px;
                font-weight: 700;
                margin: 0 0 12px;
                letter-spacing: 0.3px;
              }
              .grid {
                border: 1px solid #9ca3af;
                border-bottom: 0;
              }
              .row {
                display: grid;
                grid-template-columns: 180px 1fr 130px 180px;
                border-bottom: 1px solid #9ca3af;
                min-height: 34px;
              }
              .cell {
                padding: 7px 8px;
                border-right: 1px solid #9ca3af;
                display: flex;
                align-items: center;
                font-size: 14px;
              }
              .cell:last-child { border-right: 0; }
              .label {
                background: #f3f4f6;
                font-weight: 700;
              }
              .value { font-weight: 600; }
              .wrap {
                word-break: break-word;
                white-space: pre-wrap;
              }
              .obs {
                min-height: 58px;
                white-space: pre-wrap;
                align-items: flex-start;
                padding-top: 10px;
              }
              .link {
                color: #2563eb;
                text-decoration: underline;
              }
              .sub-title {
                margin: 10px 0 6px;
                font-size: 15px;
                font-weight: 700;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
              }
              th, td {
                border: 1px solid #9ca3af;
                padding: 6px 7px;
                font-size: 14px;
              }
              th {
                background: #f3f4f6;
                text-transform: uppercase;
                font-size: 13px;
                font-weight: 700;
              }
              .ta-r { text-align: right; }
              .ta-c { text-align: center; }
              .totals-wrap {
                display: flex;
                justify-content: flex-end;
                margin-top: 8px;
              }
              .totals {
                width: 320px;
              }
              .totals .line {
                display: flex;
                justify-content: space-between;
                padding: 4px 0;
                border-bottom: 1px solid #d1d5db;
                font-size: 16px;
              }
              .totals .line strong { font-size: 18px; }
              .signature {
                margin-top: 28px;
                text-align: center;
                break-inside: avoid;
                page-break-inside: avoid;
              }
              .signature-image {
                display: block;
                max-height: 90px;
                max-width: 320px;
                margin: 0 auto -14px;
              }
              .signature-line {
                margin: 0 auto 8px;
                width: 360px;
                border-top: 1px solid #111827;
              }
              .signature-name {
                font-size: 16px;
                font-weight: 700;
              }
              .signature-role {
                font-size: 13px;
                color: #4b5563;
              }
              @page { size: auto; margin: 0; }
            </style>
          </head>
          <body>
            <div class="sheet">
              <h1 class="title">${escapeHtml(root.$t('purchaseOrderPrint.orderTitle'))}</h1>

              <div class="grid">
                <div class="row">
                  <div class="cell label">${escapeHtml(root.$t('purchaseOrderPrint.orderLabel'))}</div>
                  <div class="cell value">${escapeHtml(ocFolio)}</div>
                  <div class="cell label">${escapeHtml(root.$t('date'))}</div>
                  <div class="cell value">${escapeHtml(dateText)}</div>
                </div>
                <div class="row">
                  <div class="cell label">${escapeHtml(root.$t('project'))}</div>
                  <div class="cell value">${escapeHtml(projectName)}</div>
                  <div class="cell label">${escapeHtml(root.$t('purchaseOrderPrint.buyer'))}</div>
                  <div class="cell value">${escapeHtml(buyerName)}</div>
                </div>
                <div class="row">
                  <div class="cell label">${escapeHtml(root.$t('address'))}</div>
                  <div class="cell value wrap" style="grid-column: span 3;">${escapeHtml(projectAddress || '—')}</div>
                </div>
                <div class="row">
                  <div class="cell label">Google Maps</div>
                  <div class="cell value wrap" style="grid-column: span 3;">
                    ${projectMapsUrl
    ? `<a class="link" href="${escapeHtml(projectMapsUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(projectMapsUrl)}</a>`
    : '—'}
                  </div>
                </div>
                <div class="row">
                  <div class="cell label">${escapeHtml(root.$t('supplier'))}</div>
                  <div class="cell value">${escapeHtml(supplierName)}</div>
                  <div class="cell label">${escapeHtml(root.$t('purchaseOrderPrint.paymentConditions'))}</div>
                  <div class="cell value">${escapeHtml(paymentCondition)}</div>
                </div>
                <div class="row">
                  <div class="cell label">${escapeHtml(root.$t('observations'))}</div>
                  <div class="cell value obs" style="grid-column: span 3;">${escapeHtml(observations || '—')}</div>
                </div>
                <div class="row">
                  <div class="cell label">${escapeHtml(root.$t('purchaseOrderPrint.issuer'))}</div>
                  <div class="cell value" style="grid-column: span 3;">${escapeHtml(COMPANY_LEGAL_NAME)}</div>
                </div>
              </div>

              <p class="sub-title">${escapeHtml(root.$t('purchaseOrderPrint.materialsBreakdown'))}</p>
              <table>
                <thead>
                  <tr>
                    <th style="width: 110px;">${escapeHtml(root.$t('quantity'))}</th>
                    <th style="width: 90px;">${escapeHtml(root.$t('unit'))}</th>
                    <th>${escapeHtml(root.$t('description'))}</th>
                    <th style="width: 150px;">${escapeHtml(root.$t('unitPrice'))}</th>
                    <th style="width: 170px;">${escapeHtml(root.$t('total'))}</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                  ${fillerRows}
                </tbody>
              </table>

              <div class="totals-wrap">
                <div class="totals">
                  <div class="line"><span>${escapeHtml(root.$t('subtotal'))}</span><span><strong>$ ${escapeHtml(formatMoneyNoCurrency(subtotalAmount))}</strong></span></div>
                  <div class="line"><span>${escapeHtml(root.$t('shipping') || 'Flete')}</span><span><strong>$ ${escapeHtml(formatMoneyNoCurrency(shippingAmount))}</strong></span></div>
                  <div class="line"><span>${escapeHtml(root.$t('vat'))}</span><span><strong>$ ${escapeHtml(formatMoneyNoCurrency(vatAmount))}</strong></span></div>
                  <div class="line"><span>${escapeHtml(root.$t('total'))}</span><span><strong>$ ${escapeHtml(formatMoneyNoCurrency(totalAmount))}</strong></span></div>
                </div>
              </div>

              <div class="signature">
                <img class="signature-image" src="${escapeHtml(signatureUrl)}" alt="" onerror="this.remove()" />
                <div class="signature-line"></div>
                <div class="signature-name">${escapeHtml(directorName)}</div>
                <div class="signature-role">${escapeHtml(directorRole)}</div>
              </div>
            </div>
          </body>
        </html>
      `
    }

    function fitPrintSheetToOnePage(doc) {
      const sheet = doc.querySelector('.sheet')
      if (!sheet) return

      const mmToPx = 96 / 25.4
      const pageHeightPx = 279.4 * mmToPx
      const paddingBottomPx = 10 * mmToPx
      const signature = doc.querySelector('.signature')
      const fillers = Array.from(doc.querySelectorAll('tr.filler')).reverse()
      const contentBottom = () => (signature || sheet.lastElementChild).getBoundingClientRect().bottom
        - sheet.getBoundingClientRect().top + paddingBottomPx
      const overflows = () => contentBottom() > pageHeightPx - 8

      while (overflows() && fillers.length) {
        fillers.shift().remove()
      }
    }

    const openPrintWindow = html => {
      const printWindow = window.open('', '_blank', 'width=1100,height=900')
      if (!printWindow) {
        toast({ title: root.$t('purchaseOrderPrint.popupBlocked'), variant: 'danger' })
        return false
      }

      printWindow.document.open()
      printWindow.document.write(html)
      printWindow.document.close()
      printWindow.focus()

      // La firma es una imagen: si se imprime antes de que cargue, sale en blanco. Se espera
      // a todas las imagenes del documento (cargadas o fallidas) y luego el margen de render.
      const images = Array.from(printWindow.document.images)
      const settled = images.map(img => (img.complete
        ? Promise.resolve()
        : new Promise(resolve => {
          img.onload = resolve
          img.onerror = resolve
        })))

      Promise.all(settled).then(() => {
        fitPrintSheetToOnePage(printWindow.document)
        setTimeout(() => {
          printWindow.print()
          printWindow.close()
        }, 280)
      })

      return true
    }

    function openPrintPurchaseOrderModal() {
      if (!purchaseOrderSuppliers.value.length) {
        toast({ title: root.$t('purchaseOrderPrint.noSuppliers'), variant: 'warning' })
        return
      }

      if (!selectedPurchaseOrderSupplierId.value) {
        selectedPurchaseOrderSupplierId.value = purchaseOrderSuppliers.value[0].id
      }

      root.$bvModal.show('printPurchaseOrderBySupplierAdmin')
    }

    function printPurchaseOrderBySupplier(modalEvent) {
      if (modalEvent && typeof modalEvent.preventDefault === 'function') {
        modalEvent.preventDefault()
      }

      if (!selectedPurchaseOrderSupplierId.value) {
        toast({ title: root.$t('purchaseOrderPrint.supplierRequired'), variant: 'warning' })
        return
      }

      const rows = selectedPurchaseOrderItems.value.map(item => {
        const unitType = item?.product_catalog?.unit_type || item?.unit_type || 'noUnit'
        const unitsFilter = store.getters['app/unitsFilter']
        const unitKey = typeof unitsFilter === 'function' ? unitsFilter(unitType) : unitType

        return {
          quantity: toNumber(item?.quantity),
          unit: root.$tc(unitKey, toNumber(item?.quantity) || 1),
          description: item?.product_catalog?.name || item?.name || root.$t('product'),
          unitPrice: getItemUnitPriceWithoutCommission(item),
          amount: getItemTotalWithoutCommission(item),
        }
      })

      if (!rows.length) {
        toast({ title: root.$t('purchaseOrderPrint.emptyItems'), variant: 'warning' })
        return
      }

      const printHtml = buildPurchaseOrderPrintHtml({
        supplierName: selectedPurchaseOrderSupplier.value?.name || root.$t('supplier'),
        projectName: props.project?.name || root.$t('project'),
        projectAddress: normalizeText(props.project?.address?.formatted_address),
        projectMapsUrl: normalizeText(props.project?.google_maps_url),
        observations: props.project?.observations || root.$t('noObservations'),
        rows,
        subtotalAmount: purchaseOrderSubtotal.value,
        shippingAmount: purchaseOrderShippingTotal.value,
        vatAmount: purchaseOrderVatTotal.value,
        totalAmount: purchaseOrderGrandTotal.value,
        dateText: formatDate(q.value?.published_at || new Date()),
        ocFolio: `OC-${q.value?.folio || quoteId.value || ''}`,
        paymentCondition: root.$t('credit'),
        buyerName: root.$t('purchaseOrderPrint.defaultBuyer'),
        directorName: root.$t('purchaseOrderPrint.defaultDirector'),
        directorRole: root.$t('purchaseOrderPrint.directorRole'),
      })

      const opened = openPrintWindow(printHtml)
      if (opened) root.$bvModal.hide('printPurchaseOrderBySupplierAdmin')
    }

    const subtotal = computed(() => Number(q.value.subtotal || 0))
    const shippingTotal = computed(() => Number(q.value.shipping_total || 0))
    const ivaTotal = computed(() => Number(q.value.iva_total || q.value.tax_total || 0))
    // Si tu backend ya regresa total con IVA, úsalo. Si no, podrías sumar subtotal + shipping + iva.
    const total = computed(() => {
      const t = Number(q.value.total)
      if (!Number.isNaN(t) && t > 0) return t
      return subtotal.value + shippingTotal.value + ivaTotal.value
    })
    const cashTotalAmount = computed(() => Number(q.value?.cash_total_amount || total.value || 0))
    const creditTotalAmount = computed(() => Number(q.value?.credit_total_amount || cashTotalAmount.value || 0))

    // Pagos registrados
    const paymentsSum = computed(() => (payments.value || []).reduce((acc, p) => acc + Number(p.amount || 0), 0))

    const remainingToPay = computed(() => {
      const rest = Number(total.value) - Number(paymentsSum.value)
      return rest > 0 ? rest : 0
    })

    async function onRequoteQuote() {
      try {
        isRequoting.value = true
        const sourceQuoteId = root.$route.params.quoteId || q.value?.id

        if (!sourceQuoteId) {
          throw new Error(root.$t('quoteNotFoundForRequote'))
        }

        const newQuote = await store.dispatch('quotes/requoteQuote', {
          quoteId: sourceQuoteId,
          mode: pendingRequoteMode.value,
        })

        root.$toast({
          component: ToastificationContent,
          props: {
            title: root.$t('quoteRequoted'),
            icon: 'CopyIcon',
            variant: 'success',
          },
        })

        if (String(newQuote.id) === String(sourceQuoteId)) {
          const targetRoute = resolveQuoteRoute({
            quote: newQuote,
            currentUser: store.getters['auth/currentUser'] || {},
            routeParams: root.$route.params,
          })
          if (targetRoute) {
            await root.$router.push(targetRoute).catch(() => {})
          } else {
            await store.dispatch('quotes/fetchQuote', sourceQuoteId)
          }
          return
        }

        await root.$router.push({
          name: 'addProductsToQuote',
          params: { quoteId: newQuote.id },
        })
      } catch (err) {
        const msg = err?.data?.messages?.[0] || err?.statusText || err?.message || root.$t('quoteRequoteFailed')
        root.$toast({
          component: ToastificationContent,
          props: {
            title: msg,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isRequoting.value = false
      }
    }

    async function gotoPurchaseOrder(id) {
      try {
        // 1) intenta por nombre de ruta (ajusta si tu nombre real es otro)
        await root.$router.replace({ name: 'purchaseOrder', params: { id } })
      } catch (e) {
        // 2) fallback por path literal (tu URL en español)
        await root.$router.replace({ path: `/orden-de-compra/${id}` })
      }
    }

    async function approvePayment({ selectedPaymentMode = null, applyCreditSurcharge = null } = {}) {
      if (!hasTaxInformationLinked.value) {
        toast({
          title: 'Debes seleccionar una razón social de facturación antes de aprobar el pago.',
          variant: 'warning',
        })
        return false
      }
      try {
        await store.dispatch('quotes/approvePayment', {
          quoteId: quoteId.value,
          selectedPaymentMode,
          applyCreditSurcharge,
        })
        toast({ title: root.$t('paymentApproved') })

        const id = quoteId.value
        await gotoPurchaseOrder(id)
        return true
      } catch (err) {
        const code = getErrorCode(err)
        const msg = getErrorMessage(err)

        if (code === 'QUOTE_PAYMENT_WINDOW_EXPIRED') {
          toast({ title: msg || 'Cotización vencida', variant: 'warning' })
          return false
        }

        toast({ title: msg, variant: 'danger' })
        return false
      }
    }

    function rejectPayment() {
      store.dispatch('quotes/rejectPayment', { quoteId: quoteId.value })
        .then(() => toast({ title: root.$t('paymentRejected'), variant: 'warning' }))
        .catch(error => toast({ title: getErrorMessage(error), variant: 'danger' }))
    }

    async function creditPayment(applyCreditSurcharge = true) {
      try {
        await store.dispatch('quotes/creditPayment', {
          quoteId: quoteId.value,
          applyCreditSurcharge,
        })
        toast({ title: root.$t('paymentCredit'), variant: 'warning' })

        const id = quoteId.value
        await gotoPurchaseOrder(id)
        return true
      } catch (err) {
        const code = getErrorCode(err)
        const msg = getErrorMessage(err)

        if (code === 'QUOTE_PAYMENT_WINDOW_EXPIRED') {
          toast({ title: msg || 'Cotización vencida', variant: 'warning' })
          return false
        }

        toast({ title: msg, variant: 'danger' })
        return false
      }
    }

    async function confirmPaymentSelection(modalEvent) {
      modalEvent.preventDefault()

      if (selectedApprovalMode.value === 'cash' && !canApproveCash.value) {
        toast({
          title: root.$t('cashApprovalRequiresPaymentProof'),
          variant: 'warning',
        })
        return
      }

      let success = false

      if (selectedApprovalMode.value === 'cash') {
        success = await approvePayment({
          selectedPaymentMode: 'cash',
          applyCreditSurcharge: false,
        })
      } else if (selectedApprovalMode.value === 'credit_without_surcharge') {
        success = canApproveUploadedProof.value
          ? await approvePayment({
            selectedPaymentMode: 'credit',
            applyCreditSurcharge: false,
          })
          : await creditPayment(false)
      } else {
        success = canApproveUploadedProof.value
          ? await approvePayment({
            selectedPaymentMode: 'credit',
            applyCreditSurcharge: true,
          })
          : await creditPayment(true)
      }

      if (success) {
        root.$bvModal.hide('selectPaymentModeBeforeApproval')
      }
    }

    async function payWithWalletConfirm() {
      try {
        if (Number(walletBalance.value) < Number(remainingToPay.value)) {
          toast({ title: (root.$t('insufficientWallet') || 'Saldo insuficiente'), variant: 'warning' })
          return
        }
        const amount = remainingToPay.value
        const idempotencyKey = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now())

        await store.dispatch('quotes/payWithWallet', {
          quoteId: quoteId.value,
          amount,
          idempotencyKey,
        })
        toast({ title: (root.$t('walletPaymentOk') || 'Pago con monedero realizado') })
        root.$bvModal.hide('confirmWallet')

        await gotoPurchaseOrder(quoteId.value)
      } catch (err) {
        const code = getErrorCode(err)
        const msg = getErrorMessage(err)

        if (code === 'QUOTE_PAYMENT_WINDOW_EXPIRED') {
          toast({ title: msg || 'Cotización vencida', variant: 'warning' })
          return
        }

        toast({ title: msg, variant: 'danger' })
      }
    }

    async function handlePaymentStateChange() {
      if (!quoteId.value) return

      try {
        const refreshedQuote = await store.dispatch('quotes/fetchQuote', quoteId.value)
        await store.dispatch('quotes/getQuotePayments', {
          quoteId: quoteId.value,
        })

        if (typeof props.refetch === 'function') {
          await props.refetch()
        }

        const targetRoute = resolveQuoteRoute({
          quote: refreshedQuote,
          currentUser: store.getters['auth/currentUser'] || {},
          routeParams: root.$route.params,
        })
        const resolvedTarget = targetRoute ? root.$router.resolve(targetRoute).route : null
        const targetFullPath = resolvedTarget?.fullPath

        if (targetFullPath && targetFullPath !== root.$route.fullPath) {
          window.location.replace(targetFullPath)
        }
      } catch (error) {
        toast({
          title: getErrorMessage(error, 'No se pudo refrescar la cotización después de guardar el comprobante.'),
          variant: 'danger',
        })
      }
    }

    return {
    // ui
      isQuoteOpen,
      isSavingVisibility,
      comparativeLayout,
      comparativeLayoutOptions,
      isSavingLayout,
      saveComparativeLayout,
      toggleQuoteVisibility,
      printInvoice,
      openPrintPurchaseOrderModal,
      printPurchaseOrderBySupplier,
      purchaseOrderSupplierSelectOptions,
      selectedPurchaseOrderSupplierId,
      apiUrl,
      formatMoney,
      // acciones
      approvePayment,
      rejectPayment,
      creditPayment,
      payWithWalletConfirm,
      gotoPurchaseOrder,
      openApproveFlow,
      openTaxInformationModal,
      confirmPaymentSelection,
      resetPaymentSelection,
      hasTaxInformationLinked,
      uploadPaymentRef,
      confirmTaxInformationSelection,
      resetTaxInformationModal,
      goToNewBilling,
      taxInformationLoading,
      taxInformationOptions,
      taxInformationSelectOptions,
      selectedTaxInformationId,
      // datos para el modal
      payments,
      paymentsSum,
      remainingToPay,
      subtotal,
      shippingTotal,
      ivaTotal,
      total,
      cashTotalAmount,
      creditTotalAmount,
      customerCreditEligible,
      paymentSelectionAvailable,
      adminPaymentSelectionAvailable,
      creditSurchargePercentage,
      creditLimitWarningWithSurcharge,
      creditLimitWarningWithoutSurcharge,
      selectedCreditLimitWarning,
      canApproveCash,
      hasPendingProofApproval,
      selectedApprovalMode,
      walletBalance,
      paymentWindowExpired,
      paymentDeadlineAt,
      paymentDeadlineLabel,
      deadlineUpcoming,
      deadlineUrgent,
      deadlineVariant,
      handlePaymentStateChange,
      onRequoteQuote,
      isRequoting,
      quoteHasPaymentActivity,
      pendingRequoteMode,
      requoteConfirmMessage,
      openRequoteConfirm,
    }
  },

}
</script>

<style scoped>
.quote-visibility {
  border: 1px solid #ebe9f1;
  border-radius: 0.4rem;
  padding: 0.6rem 0.75rem;
}

.quote-visibility__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.quote-visibility__label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #6e6b7b;
}
</style>
